import loader from './pageLoader';
import loaderApp from './appLoader';
import App from '../containers/HubPageApp';

loader(() => loaderApp(App, () => module.hot.accept()));

